module.exports = __webpack_public_path__ + "resources/img/sp_cheating_detection.0321e74e45d15c04801d68dfb1c9a675.png";